// Define unique string identifiers for each action type
export const SET_INVENTORY2_FILTERS = 'SET_INVENTORY2_FILTERS';
export const SET_INVENTORY2_DATE_RANGE = 'SET_INVENTORY2_DATE_RANGE';
export const SET_INVENTORY2_DATA = 'SET_INVENTORY2_DATA';
export const CLEAR_INVENTORY2_STATE = 'CLEAR_INVENTORY2_STATE';


// Creates an action object to update filters in Redux store
export const setInventory2Filters = (filters: any[]) => ({
  type: SET_INVENTORY2_FILTERS,
  payload: filters,
});

export const setInventory2DateRange = (dateRange: [string, string] | null) => ({
  type: SET_INVENTORY2_DATE_RANGE,
  payload: dateRange,
});

export const setInventory2Data = (data: any) => ({
  type: SET_INVENTORY2_DATA,
  payload: data,
});

export const clearInventory2State = () => ({
  type: CLEAR_INVENTORY2_STATE,
});
